module.exports = __webpack_public_path__ + "static/media/05.a71eb35f.jpg";